import React from 'react';

export const hostCardStyle = {
  backgroundColor: 'var(--surface)',
  borderRadius: 24,
  border: '1px solid var(--card-border)',
  boxShadow: 'var(--premium-shadow-main)',
};

export const hostNestedCardStyle = {
  ...hostCardStyle,
  boxShadow: 'var(--premium-shadow-nested)',
};

export const HostSettingsCard = ({ children, style, ...props }) => (
  <div
    style={{
      ...hostCardStyle,
      width: '100%',
      padding: '16px 16px',
      ...style,
    }}
    {...props}
  >
    {children}
  </div>
);

export const HostActionRow = ({ label, icon, onClick, dataTestId, disabled = false }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    data-testid={dataTestId}
    style={{
      ...hostCardStyle,
      width: '100%',
      padding: '16px 18px',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      cursor: disabled ? 'default' : 'pointer',
      opacity: disabled ? 0.7 : 1,
      transform: 'translateY(0)',
      transition: 'transform 180ms ease, box-shadow 180ms ease',
    }}
  >
    <span style={{ fontFamily: "'Inria Serif', serif", fontSize: 18, color: 'var(--text)', textAlign: 'left' }}>{label}</span>
    <span style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>{icon}</span>
  </button>
);

export const HostToggleRow = ({ label, description, checked, onChange, dataTestId }) => (
  <div style={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'space-between', gap: 12, padding: '8px 0' }}>
    <div>
      <p style={{ fontFamily: "'Inria Serif', serif", fontSize: 15, color: 'var(--text)', margin: 0 }}>{label}</p>
      {description && <p style={{ fontFamily: "'Inria Serif', serif", fontSize: 12, color: 'var(--text-2)', margin: '4px 0 0', lineHeight: 1.4 }}>{description}</p>}
    </div>
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      aria-label={label}
      onClick={onChange}
      data-testid={dataTestId}
      style={{
        width: 54,
        height: 30,
        borderRadius: 999,
        border: '1px solid rgba(112, 63, 246, 0.1)',
        backgroundColor: checked ? 'var(--accent-purple)' : 'var(--accent-surface)',
        padding: 3,
        cursor: 'pointer',
        display: 'flex',
        alignItems: 'center',
        justifyContent: checked ? 'flex-end' : 'flex-start',
        transition: 'background-color 180ms ease, justify-content 180ms ease',
        flexShrink: 0,
      }}
    >
      <span style={{ width: 24, height: 24, borderRadius: '50%', backgroundColor: '#fff', boxShadow: '0 1px 2px rgba(0,0,0,0.15)' }} />
    </button>
  </div>
);

export const HostPrimaryButton = ({ children, onClick, dataTestId, disabled = false, style }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    data-testid={dataTestId}
    style={{
      width: '100%',
      maxWidth: 240,
      alignSelf: 'center',
      padding: '14px 16px',
      fontFamily: "'Inria Serif', serif",
      fontSize: 18,
      fontWeight: 700,
      color: 'var(--accent-text-soft)',
      background: 'var(--surface)',
      border: '1px solid var(--card-border)',
      borderRadius: 9999,
      cursor: disabled ? 'default' : 'pointer',
      opacity: disabled ? 0.55 : 1,
      boxShadow: 'var(--premium-shadow-main)',
      transition: 'transform 180ms ease, box-shadow 180ms ease, opacity 180ms ease',
      display: 'inline-flex',
      alignItems: 'center',
      justifyContent: 'center',
      gap: 8,
      lineHeight: 1,
      ...style,
    }}
  >
    {children}
  </button>
);